export default {
    unit_type_events_list_title: "Unit Type Events List",
    unit_type_events_list_name: "Name",
    unit_type_events_list_status: "Status",
    unit_type_events_list_active: "Active",
    unit_type_events_list_inactive: "Inactive",
    unit_type_events_list_diagnostic: "Diagnostic",
    unit_type_events_list_tab_general: "General",
    unit_type_events_list_tab_unit_type_event: "Unit Type Event",
    unit_type_events_list_raw_event: "Raw Event",
    unit_type_events_list_manufaturers: "Manufaturers",
}